import { css } from "lit";

export const landingStyles = css`
  .hollo-landing {
    display: grid;
    grid-template-rows: 1fr auto;
    place-items: stretch;
    height: 100%;
    position: relative;
    border: none;
    border-bottom: none;
    box-shadow: none;
    outline: none;
    overflow: hidden;
  }
  .hollo-live-landing-height {
    height: 200px;
  }

  @media (max-width: 460px) {
    .hollo-live-landing-height {
      height: 40dvh;
    }
  }

  .hollo-messages {
    overflow-y: auto;
    overflow-x: hidden;
    display: grid;
    align-content: start;
    gap: 8px;
    scroll-behavior: smooth;
    scroll-padding-bottom: 80px;
    padding-bottom: 80px;
    min-height: 0;
    height: 100%;
    overflow-anchor: none;

    /* Custom scrollbar styles */
    --sb-track-color: #f9fafb;
    --sb-thumb-color: #d1d5db;
    --sb-size: 6px;
  }
  
  .hollo-messages:has(.hollo-empty-container) {
    overflow-y: auto;
    padding-top: 0;
    padding-bottom: 8px;
    align-content: end;
  }

  .hollo-messages::-webkit-scrollbar {
    width: 0;
    display: none;
  }

  .hollo-messages::-webkit-scrollbar-track {
    display: none;
  }

  .hollo-messages::-webkit-scrollbar-thumb {
    display: none;
  }

  .hollo-messages::-webkit-scrollbar-thumb:hover {
    display: none;
  }

  @supports not selector(::-webkit-scrollbar) {
    .hollo-messages {
      scrollbar-width: none;
      scrollbar-color: transparent transparent;
    }
  }
  
  .hollo-messages {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .hollo-row {
    display: flex;
    animation: hollo-message-enter 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)
      backwards;
    will-change: transform, opacity;
  }
  .hollo-row.hollo-left {
    justify-content: flex-start;
    transform-origin: left bottom;
  }
  .hollo-row.hollo-right {
    justify-content: flex-end;
    transform-origin: right bottom;
  }

  @keyframes hollo-message-enter {
    from {
      opacity: 0;
      transform: scale(0.96) translateY(4px);
    }
    to {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }

  .hollo-bubble-box {
    position: relative;
    max-width: 65%;
    padding-bottom: 8px;
  }
  .hollo-bubble {
    display: inline-block;
    width: fit-content;
    max-width: 100%;
    min-width: 0;
    padding: 8px 12px;
    border-radius: 12px;

    color: #021820;
    font-size: 13px;
    line-height: 1.5;
    font-weight: 400;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    word-wrap: break-word;
    box-shadow: none;
    position: relative;
  }
  .hollo-row.hollo-right .hollo-audio-bubble .hollo-bubble {
    max-width: 100%;
  }
  .hollo-message-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;
    padding-top: 4px;
    border-top: none;
    width: 100%;
  }
  .hollo-user-message-footer {
    justify-content: flex-end;
    margin-top: 6px;
    padding-top: 4px;
    display: flex !important;
    visibility: visible !important;
  }
  .hollo-user-message-footer .hollo-message-timestamp {
    opacity: 0.9 !important;
    color: rgba(255, 255, 255, 0.9) !important;
    font-size: 11px;
    margin-top: 2px;
    display: block !important;
    visibility: visible !important;
  }
  .hollo-message-icons {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .hollo-message-icon-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6c7e85;
    width: auto;
    height: auto;
    min-width: 28px;
    min-height: 28px;
    border-radius: 8px;
    opacity: 0.6;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
  }
  .hollo-message-icon-btn:hover {
    opacity: 1;
    color: #4b5563;
    background: rgba(0, 0, 0, 0.04);
  }
  .hollo-message-icon-btn:hover svg,
  .hollo-message-icon-btn:hover svg path,
  .hollo-message-icon-btn:hover svg rect,
  .hollo-message-icon-btn:hover svg circle,
  .hollo-message-icon-btn:hover svg polygon {
    color: #000000;
  }
  .hollo-message-icon-btn:active {
    opacity: 0.8;
  }
  .hollo-message-icon-btn.hollo-audio-playing {
    opacity: 1;
  }
  .hollo-message-icon-btn.hollo-audio-playing svg {
    animation: hollo-audio-pulse 1.5s ease-in-out infinite;
  }
  @keyframes hollo-audio-pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.8;
    }
  }
  .hollo-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    height: 100%;
  }
  .hollo-icon-wrapper svg,
  .hollo-icon-wrapper span {
    display: block;
    flex-shrink: 0;
    animation: hollo-icon-fade-in 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    transition: stroke 0.2s ease, color 0.2s ease, fill 0.2s ease;
  }
  .hollo-icon-wrapper svg path,
  .hollo-icon-wrapper svg rect,
  .hollo-icon-wrapper svg circle,
  .hollo-icon-wrapper svg polygon {
    transition: stroke 0.2s ease, fill 0.2s ease;
  }
  @keyframes hollo-icon-fade-in {
    from {
      opacity: 0;
      transform: rotate(-8deg);
    }
    to {
      opacity: 1;
      transform: rotate(0deg);
    }
  }
  .hollo-message-icon-btn.hollo-icon-copied .hollo-icon-wrapper svg {
    animation: hollo-icon-success 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  }
  @keyframes hollo-icon-success {
    0% {
      opacity: 0;
      transform: rotate(-15deg);
    }
    50% {
      transform: rotate(5deg);
    }
    100% {
      opacity: 1;
      transform: rotate(0deg);
    }
  }
  .hollo-message-icon-btn.hollo-video-active .hollo-icon-wrapper svg {
    animation: hollo-icon-pulse 0.3s ease-out;
  }
  @keyframes hollo-icon-pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
  }
  .hollo-message-timestamp {
    color: #6c7e85;
    font-size: 12px;
    font-weight: 400;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    line-height: 1;
    white-space: nowrap;
    opacity: 0.7;
  }
  /* Disable old CSS square tails; we now render SVG tails */
  .hollo-row.hollo-left .hollo-bubble::after,
  .hollo-row.hollo-right .hollo-bubble::after {
    content: none;
    display: none;
  }
  .hollo-row.hollo-left .hollo-bubble {
    background: #ffffff;
    border: none;
    box-shadow: none;
    color: #021820;
    border-radius: 12px;
  }
  /* Tail positioning and sizing */
  .hollo-tail {
    position: absolute;
    width: 16.5px;
    height: 17px;
    z-index: 3;
  }
  .hollo-tail svg {
    display: block;
    width: 100%;
    height: 100%;
  }
  .hollo-tail-left {
    left: 6px; /* align near left radius */
    bottom: 6px; /* visually attach to bubble */
  }
  .hollo-tail-right {
    right: -5px;
    bottom: 6px;
    transform: scaleX(-1); /* mirror to point right */
  }
  .hollo-row.hollo-right .hollo-bubble {
    background: var(--hollo-user-bubble-bg, #3784ff);
    color: #ffffff;
    border: none;
    box-shadow: none;
    border-radius: 12px;
  }
  /* end tails */

  .hollo-bubble.hollo-typing {
    display: inline-flex;
    gap: 6px;
    align-items: center;
    justify-content: center;
    padding: 10px 16px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
    animation: hollo-typing-bubble-enter 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  @keyframes hollo-typing-bubble-enter {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  .hollo-bubble.hollo-typing .hollo-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #9ca3af;
    animation: hollo-typing-dot 1.4s infinite ease-in-out;
    transform-origin: center;
  }
  .hollo-bubble.hollo-typing .hollo-dot:nth-child(1) {
    background: var(--hollo-typing-dot-color, #3784ff);
    animation-delay: 0s;
  }
  .hollo-bubble.hollo-typing .hollo-dot:nth-child(2) {
    background: #9ca3af;
    animation-delay: 0.2s;
  }
  .hollo-bubble.hollo-typing .hollo-dot:nth-child(3) {
    background: #9ca3af;
    animation-delay: 0.4s;
  }
  @keyframes hollo-typing-dot {
    0%,
    100% {
      opacity: 0.3;
      transform: scale(0.7) translateY(0);
    }
    50% {
      opacity: 1;
      transform: scale(1) translateY(-2px);
    }
  }

  .hollo-bubble-fab {
    position: relative;
    border-radius: 999px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #fff;
    background: transparent;
    box-shadow: none;
    pointer-events: auto;
    width: 24px;
    height: 24px;
  }
  .hollo-row.hollo-right .hollo-bubble-fab {
    display: none;
  }

  span.hollo-spinner-small {
    width: 14px;
    height: 14px;
    max-width: 14px;
    max-height: 14px;
    min-width: 14px;
    min-height: 14px;
    border: 2px solid #6c7e85;
    border-top-color: #fff;
    border-radius: 50%;
    animation: hollo-spin 0.8s linear infinite !important;
    display: inline-block;
  }
  @keyframes hollo-spin {
    to {
      transform: rotate(360deg);
    }
  }

  .hollo-empty-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    min-height: 100%;
    padding: 0;
    gap: 6px;
    margin-top: auto;
    animation: hollo-landing-fade-in 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  }
  @keyframes hollo-landing-fade-in {
    from {
      opacity: 0;
      transform: translateY(6px) scale(0.98);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
  .hollo-avatar {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    object-fit: cover;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  .hollo-empty-container .hollo-avatar {
    box-shadow: 0 20px 60px rgba(147, 51, 234, 0.3),
      0 0 80px rgba(236, 72, 153, 0.2), 0 0 100px rgba(59, 130, 246, 0.15);
    position: relative;
  }
  .hollo-empty-container .hollo-avatar::after {
    content: "";
    position: absolute;
    inset: -8px;
    border-radius: 50%;
    background: linear-gradient(135deg, #9333ea 0%, #ec4899 50%, #3b82f6 100%);
    opacity: 0.4;
    filter: blur(20px);
    z-index: -1;
    animation: hollo-avatar-glow 4s ease-in-out infinite;
  }
  @keyframes hollo-avatar-glow {
    0%,
    100% {
      opacity: 0.3;
      transform: scale(1);
    }
    50% {
      opacity: 0.6;
      transform: scale(1.1);
    }
  }
  .hollo-empty-container:hover .hollo-avatar {
    transform: scale(1.05);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  }
  .hollo-prompt {
    margin: 18px 0 24px;
    text-align: center;
    color: #6b21a8;
    font-weight: 500;
    font-size: 16px;
    animation: hollo-prompt-fade-in 0.5s ease-out 0.2s both;
  }
  @keyframes hollo-prompt-fade-in {
    from {
      opacity: 0;
      transform: translateY(5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Landing Header */
  .hollo-landing-header {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    margin-bottom: 0;
    margin-top: 0;
    padding: 0;
  }
  .hollo-sparkle-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #1e1e1e;
  }
  .hollo-sparkle-icon svg {
    display: block;
    width: 22px;
    height: 22px;
    filter: drop-shadow(0 0 8px rgba(55, 132, 255, 0.3));
  }
  .hollo-header-title {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.35;
    color: #021820;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    padding: 0;
    animation: hollo-landing-fade-in 0.4s cubic-bezier(0.16, 1, 0.3, 1) 0.05s
      both;
  }
  .hollo-highlight {
    color: var(--hollo-highlight-color, #3784ff);
    position: relative;
    display: inline-block;
  }

  /* Suggestions Section */
  .hollo-suggestions-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    margin-top: 12px;
    margin-bottom: 8px;
    padding: 0;
  }
  .hollo-suggestions-title {
    font-size: 13px;
    font-weight: 500;
    line-height: 1.4;
    color: #021820;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    margin: 0;
    padding: 0;
    animation: hollo-landing-fade-in 0.4s cubic-bezier(0.16, 1, 0.3, 1) 0.1s
      both;
  }
  .hollo-suggestions-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
  }
  
  @media (max-width: 460px) {
    .hollo-suggestions-grid {
      grid-template-columns: 1fr;
      gap: 8px;
    }
  }
  .hollo-suggestion-btn {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 8px 10px;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 12px;
    color: #4b5563;
    font-size: 12px;
    font-weight: 500;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    line-height: 1.4;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: left;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    animation: hollo-landing-fade-in 0.4s cubic-bezier(0.16, 1, 0.3, 1)
      backwards;
  }
  .hollo-suggestion-btn:nth-child(1) {
    animation-delay: 0.1s;
  }
  .hollo-suggestion-btn:nth-child(2) {
    animation-delay: 0.15s;
  }
  .hollo-suggestion-btn:nth-child(3) {
    animation-delay: 0.2s;
  }
  .hollo-suggestion-btn:nth-child(4) {
    animation-delay: 0.25s;
  }
  .hollo-suggestion-btn:nth-child(5) {
    animation-delay: 0.3s;
  }
  .hollo-suggestion-btn:nth-child(6) {
    animation-delay: 0.35s;
  }

  .hollo-suggestion-btn:hover {
    background: #ffffff;
    border-color: var(--hollo-highlight-color, #3784ff);
    color: var(--hollo-highlight-color, #3784ff);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  }
  .hollo-suggestion-btn:active {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    transform: translateY(1px);
  }

  /* Skeleton loader for suggestions */
  .hollo-suggestion-skeleton {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 6px;
    padding: 8px 10px;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
    width: 100%;
    min-height: 50px;
    height: 100%;
    box-sizing: border-box;
    cursor: default;
    animation: hollo-skeleton-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    animation-delay: var(--delay, 0s);
  }
  .hollo-skeleton-line {
    height: 8px;
    background: #e5e7eb;
    border-radius: 9999px;
    animation: hollo-skeleton-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    animation-delay: var(--delay, 0s);
  }
  .hollo-skeleton-line-1 {
    width: 85%;
  }
  .hollo-skeleton-line-2 {
    width: 95%;
  }
  .hollo-skeleton-line-3 {
    width: 60%;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
  @keyframes hollo-skeleton-pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
  @keyframes hollo-skeleton-shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  .hollo-composer {
    width: 100%;
    display: grid;
    // grid-template-columns: 44px 1fr 44px;
    gap: 0;
    align-items: center;
    padding: 8px 0 0 0;
    background: transparent;
    border: none;
    border-bottom: none;
    margin-bottom: 0;
    margin-top: 0;
    box-shadow: none;
    outline: none;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  }
  .hollo-composer.hollo-composer-hidden {
    display: none;
  }

  .hollo-recorder-active {
    // grid-template-columns: 44px 1fr;
    align-items: center;
  }

  /* Smooth transition between message bar and recorder */
  .hollo-messageBarContainer,
  .hollo-recorderBarContainer {
    animation: hollo-composer-enter 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  }
  @keyframes hollo-composer-enter {
    from {
      opacity: 0;
      transform: translateY(4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .hollo-input {
    height: 40px;
    border-radius: 999999px;
    border: 1px solid #e5e7eb;
    padding: 0 14px;
    font-size: 16px;
    outline: none;
    background: #f9fafb;
    color: #000;
  }
  .hollo-input:focus {
    background: #fff;
    border-color: #cbd5e1;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
  }
  .hollo-icon-btn.hollo-mic {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: transparent;
    color: #9ca3af;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    flex-shrink: 0;
    padding: 0;
    margin: 0;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    transform-origin: center;
  }
  .hollo-icon-btn.hollo-mic:hover {
    transform: scale(1.05) rotate(-2deg);
    color: #4b5563;
  }
  .hollo-icon-btn.hollo-wave {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: transparent;
    color: #9ca3af;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    flex-shrink: 0;
    padding: 0;
    margin: 0;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    transform-origin: center;
  }
  .hollo-icon-btn.hollo-wave:hover {
    transform: scale(1.06) translateY(-1px);
    color: var(--hollo-highlight-color, #3784ff);
  }
  .hollo-icon-btn.hollo-send {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: transparent;
    color: #9ca3af;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    flex-shrink: 0;
    padding: 0;
    margin: 0;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    transform-origin: center;
  }
  .hollo-icon-btn.hollo-phone {
    position: relative;
    width: 32px;
    height: 32px;
    background-color: var(--hollo-phone-btn-bg, #3784ff);
    box-shadow: 0 4px 12px rgba(55, 132, 255, 0.25);
    border-radius: 99px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
    border: none;
    cursor: pointer;
    color: #fff;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    transform-origin: center;
    padding: 0 8px;
    margin: 0;
  }
  .hollo-icon-btn.hollo-phone:hover {
    width: 72px;
    gap: 6px;
    box-shadow: 0 6px 16px rgba(55, 132, 255, 0.35);
  }
  .hollo-phone-text {
    font-size: 13px;
    font-weight: 700;
    color: #ffffff;
    opacity: 0;
    max-width: 0;
    white-space: nowrap;
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .hollo-icon-btn.hollo-phone:hover .hollo-phone-text {
    opacity: 1;
    max-width: 40px;
  }
  .hollo-icon-btn.hollo-phone svg {
    flex-shrink: 0;
    transition: transform 0.3s ease;
  }
  .hollo-icon-btn.hollo-phone:hover svg {
    transform: rotate(-10deg) scale(0.9);
  }
  .hollo-icon-btn.hollo-phone:active {
    opacity: 0.9;
  }
  .hollo-icon-btn.hollo-mic svg {
    width: 22px;
    height: 22px;
  }
  .hollo-icon-btn.hollo-phone svg,
  .hollo-icon-btn.hollo-send svg {
    width: 20px;
    height: 20px;
  }
  .hollo-icon-btn.hollo-mic svg,
  .hollo-icon-btn.hollo-mic svg path,
  .hollo-icon-btn.hollo-mic svg rect {
    stroke: var(--hollo-mic-icon-color, #9ca3af) !important;
  }
  .hollo-icon-btn.hollo-mic:hover {
    background-color: transparent;
  }
  .hollo-icon-btn.hollo-mic:hover svg,
  .hollo-icon-btn.hollo-mic:hover svg path,
  .hollo-icon-btn.hollo-mic:hover svg rect {
    stroke: #6b7280 !important;
  }
  .hollo-icon-btn.hollo-send {
    background: var(--hollo-send-btn-bg, #3784FF);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
    transition: all 0.2s ease;
    padding: 0;
  }
  .hollo-icon-btn.hollo-send svg,
  .hollo-icon-btn.hollo-send svg path {
    color: #ffffff !important;
    fill: #ffffff !important;
    transition: all 0.2s ease;
  }
  .hollo-icon-btn.hollo-send:hover {
    background: var(--hollo-send-btn-bg, #3784FF);
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
    transform: scale(1.05);
  }
  .hollo-icon-btn.hollo-send:hover svg,
  .hollo-icon-btn.hollo-send:hover svg path {
    color: #ffffff !important;
    fill: #ffffff !important;
  }
  .hollo-icon-btn.hollo-send[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .hollo-audio-bubble {
    max-width: 85%;
  }
  .hollo-row.hollo-right .hollo-audio-bubble {
    max-width: 85%;
    min-width: 240px;
  }

  /* Style sender's audio player for blue bubble */
  .hollo-row.hollo-right .hollo-bubble hollo-audio-player {
    --hollo-audio-pp-bg: rgba(255, 255, 255, 0.25);
    --hollo-audio-pp-icon: #ffffff;
    --hollo-audio-track: rgba(255, 255, 255, 0.35);
    --hollo-audio-thumb: #ffffff;
    --hollo-audio-thumb-shadow: rgba(0, 0, 0, 0.2);
    --hollo-audio-time: rgba(255, 255, 255, 0.95);
  }

  .hollo-caption.transcript {
    margin-top: 8px;
    font-size: 12px;
    line-height: 1.4;
  }

  .hollo-isAiVoice {
    display: none;
  }
  .hollo-bubble-actions {
    position: absolute;
    bottom: 8px;
    right: 8px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    pointer-events: none;
    z-index: 2;
  }
  .hollo-row.hollo-right .hollo-bubble-actions {
    display: none;
  }
  .hollo-bubble-box-inner {
    display: flex;
    align-items: start;
    gap: 0.5rem;
  }
  /* New hollo- prefixed Message Bar styles */
  .hollo-messageBarContainer {
    display: flex;
    align-items: center;
    gap: 0;
    width: 100%;
    background-color: #fafafa;
    padding: 0;
    border: none;
    border-bottom: none;
    border-radius: 10px;
    margin-bottom: 0;
    box-shadow: none;
    flex-shrink: 0;
  }

  .hollo-sparkles {
    position: relative;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
  .hollo-sparkles svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  .hollo-messageBar {
    position: relative;
    flex: 1 1 0%;
    min-width: 1px;
    min-height: 40px;
    background-color: #ffffff;
    border: 0.5px solid #1602114d;
    border-radius: 10px;
    flex-shrink: 0;
    box-shadow: none;
    overflow: hidden;
    transition: background-color 0.2s ease, box-shadow 0.2s ease,
      border-color 0.2s ease;
  }
  .hollo-messageBar:focus-within {
    background-color: #ffffff;
    box-shadow: none;
    border-color: var(--hollo-input-focus-color, rgba(55, 132, 255, 0.3));
  }
  .hollo-messageBarBorder {
    display: none;
  }
  .hollo-messageBarInner {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 2;
    min-height: 40px;
    padding: 8px 0;
  }
  .hollo-messageBarContent {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;
    gap: 8px;
    padding: 0 12px;
    box-sizing: border-box;
    height: 100%;
    min-height: 40px;
    padding-bottom: 8px;
  }
  .hollo-messageBarText {
    position: relative;
    flex: 1 1 0%;
    min-width: 1px;
    min-height: 1px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    color: #111827;
    font-size: 14px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    font-weight: 400;
    line-height: 1.4;
    flex-shrink: 0;
    margin: 0;
    padding: 0;
    width: 100%;
  }
  .hollo-messageBarText p {
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
  }
  .hollo-message-input {
    border: none;
    outline: none;
    background: transparent;
    color: #111827;
    font-size: 14px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    font-weight: 400;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    line-height: 1.4;
    transition: color 0.2s ease;
  }
  .hollo-message-input::placeholder {
    color: #56637e;
    font-size: 14px;
    transition: opacity 0.2s ease;
  }
  .hollo-message-input:focus::placeholder {
    opacity: 0.5;
  }
  .hollo-message-textarea {
    min-height: 40px;
    max-height: 120px;
    resize: none;
    overflow-y: auto;
    padding: 10px 0 6px 0;
    display: block;
    align-items: flex-start;
    line-height: 1.5;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .hollo-message-textarea::-webkit-scrollbar {
    width: 4px;
  }
  .hollo-message-textarea::-webkit-scrollbar-track {
    background: transparent;
  }
  .hollo-message-textarea::-webkit-scrollbar-thumb {
    background: #9ca3af;
    border-radius: 2px;
  }
  .hollo-message-textarea::-webkit-scrollbar-thumb:hover {
    background: #6b7280;
  }

  .hollo-send {
    position: relative;
    width: 28px;
    height: 28px;
    background-color: var(--hollo-send-btn-bg, #3784FF);
    border-radius: 99px;
    flex-shrink: 0;
    overflow: hidden;
    border: none;
    display: grid;
    place-items: center;
    cursor: pointer;
    color: #fff;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    transform-origin: center;
  }
  .hollo-send svg {
    width: 16px;
    height: 16px;
  }
  .hollo-send:hover {
    background-color: #2d6fcc;
    box-shadow: 0 4px 12px rgba(55, 132, 255, 0.3);
  }
  .hollo-send:active {
    opacity: 0.9;
  }
  .hollo-send[disabled] {
    opacity: 0.5;
    cursor: default;
  }
  .hollo-up2 {
    position: absolute;
    width: 24px;
    height: 24px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: transform 0.2s ease;
  }
  .hollo-send:hover .hollo-up2 {
    transform: translate(-50%, -50%) translateY(-2px);
  }
  .hollo-up2 svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  .hollo-waves {
    position: relative;
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    overflow: hidden;
    background: #00adee;
    border-radius: 50%;
    padding: 0;
    border: none;
    display: grid;
    place-items: center;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    transform-origin: center;
  }
  .hollo-waves:hover {
    background-color: #0099d6;
    box-shadow: 0 4px 12px rgba(0, 173, 238, 0.3);
  }
  .hollo-waves:active {
    opacity: 0.9;
  }
  .hollo-wavesGroup {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .hollo-wavesGroupInner {
    position: relative;
    width: 19px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .hollo-wavesGroupInner svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  /* Recorder UI (hollo- prefixed) */
  .hollo-recorderBarContainer {
    display: flex;
    align-items: center;
    gap: 0;
    background-color: transparent;
    width: 100%;
    height: 100%;
  }
  .hollo-recorderBinButton {
    position: relative;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    overflow: visible;
    flex-shrink: 0;
    display: grid;
    place-items: center;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    margin: 0;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    transform-origin: center;
  }
  .hollo-recorderBinButton:hover {
    background-color: rgba(239, 68, 68, 0.05);
    transform: scale(1.05);
  }
  .hollo-recorderBinButton:hover .hollo-recorderBinIcon {
    animation: hollo-tilt-shake 0.5s ease-in-out infinite;
  }
  @keyframes hollo-tilt-shake {
    0%,
    100% {
      transform: rotate(0deg);
    }
    25% {
      transform: rotate(5deg);
    }
    75% {
      transform: rotate(-5deg);
    }
  }
  .hollo-recorderBinButton:hover .hollo-recorderBinIcon svg path,
  .hollo-recorderBinButton:hover .hollo-recorderBinIcon svg stroke {
    stroke: #dc2626;
  }
  .hollo-recorderBinButton:active {
    opacity: 0.5;
  }
  .hollo-recorderBinIcon {
    position: relative;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ef4444;
  }
  .hollo-recorderBinIcon svg {
    display: block;
    width: 100%;
    height: 100%;
    color: #ef4444;
  }
  .hollo-recorderBinIcon svg path,
  .hollo-recorderBinIcon svg stroke {
    stroke: #ef4444;
    fill: none;
  }
  .hollo-recorderBar {
    position: relative;
    flex: 1 1 0%;
    min-width: 1px;
    min-height: 48px;
    background-color: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    flex-shrink: 0;
    overflow: hidden;
    transition: background-color 0.2s ease;
  }
  .hollo-recorderBarBorder {
    position: absolute;
    inset: 0;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    pointer-events: none;
    z-index: 1;
  }
  .hollo-recorderBarInner {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 2;
    min-height: 48px;
  }
  .hollo-recorderBarContent {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: auto auto 1fr auto;
    align-items: center;
    width: 100%;
    padding: 0 12px;
    height: 100%;
    column-gap: 8px;
    row-gap: 0;
    position: relative;
  }
  .hollo-recordingLeft {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    min-width: fit-content;
    width: auto;
    justify-content: flex-start;
  }
  .hollo-recordingDot {
    position: relative;
    width: 10px;
    height: 10px;
    flex-shrink: 0;
    margin-right: 0;
  }
  .hollo-timerWaveformContainer {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: flex-start;
    flex: 1;
    min-width: 0;
    width: 100%;
    overflow: hidden;
    margin-left: 0;
    padding-left: 0;
  }
  .hollo-timerText {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    font-size: 14px;
    line-height: 1;
    color: #d20446;
    text-align: left;
    white-space: nowrap;
    flex-shrink: 0;
    margin: 0 0 0 8px;
    padding: 0;
    height: auto;
    min-width: fit-content;
  }
  .hollo-timerText-centered {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    margin: 0;
    padding: 0;
    pointer-events: none;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }
  .hollo-waveform-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-width: 0;
    overflow: hidden;
    padding: 0;
    flex: 1;
    width: 100%;
  }
  .hollo-recordingDot.hollo-blink {
    animation: hollo-blink-dot 1.5s ease-in-out infinite;
  }
  @keyframes hollo-blink-dot {
    0%,
    100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.3;
      transform: scale(0.9);
    }
  }
  .hollo-recordingDot svg {
    display: block;
    width: 100%;
    height: 100%;
  }
  .hollo-timerText p {
    margin: 0;
    padding: 0;
    white-space: pre;
    line-height: 1;
    font-size: 14px;
    display: inline-block;
    vertical-align: middle;
  }
  .hollo-waveform {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2px;
    height: 32px;
    flex: 1;
    min-width: 0;
    margin-right: 12px;
  }
  .hollo-waveform-bar {
    flex: 1;
    max-width: 3px;
    min-height: 4px;
    background: #9ca3af; /* gray when not talking */
    border-radius: 2px;
    transition: height 120ms cubic-bezier(0.16, 1, 0.3, 1),
      background-color 150ms ease, transform 120ms ease;
    animation: hollo-waveform-pulse 0.8s ease-in-out infinite;
  }
  .hollo-waveform.hollo-talking .hollo-waveform-bar {
    background: #021820; /* black when talking */
    transform: scaleY(1.05);
  }
  .hollo-waveform-bar:nth-child(4n + 1) {
    animation-delay: 0s;
  }
  .hollo-waveform-bar:nth-child(4n + 2) {
    animation-delay: 0.1s;
  }
  .hollo-waveform-bar:nth-child(4n + 3) {
    animation-delay: 0.2s;
  }
  .hollo-waveform-bar:nth-child(4n) {
    animation-delay: 0.3s;
  }
  @keyframes hollo-waveform-pulse {
    0%,
    100% {
      transform: scaleY(0.4);
    }
    50% {
      transform: scaleY(1);
    }
  }
  .hollo-recorderSendContainer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-shrink: 0;
    min-width: fit-content;
  }
  .hollo-recorderSendButton {
    position: relative;
    width: 32px;
    height: 32px;
    background-color: var(--hollo-recorder-send-bg, #3784ff);
    box-shadow: 0 2px 8px rgba(55, 132, 255, 0.3);
    border-radius: 99px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
    border: none;
    cursor: pointer;
    color: #fff;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    transform-origin: center;
    padding: 0 8px;
    margin: 0;
  }
  .hollo-recorderSendButton:hover {
    width: 72px;
    gap: 6px;
    box-shadow: 0 6px 16px rgba(55, 132, 255, 0.35);
  }
  .hollo-recorderSendButton:active {
    opacity: 0.9;
    transform: scale(0.98);
  }
  .hollo-recorderUpIcon {
    position: relative;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease;
  }
  .hollo-recorderSendButton:hover .hollo-recorderUpIcon {
    transform: rotate(-10deg) scale(0.9);
  }
  .hollo-recorderUpIcon svg {
    display: block;
    width: 100%;
    height: 100%;
  }
  .hollo-recorderSend-text {
    font-size: 13px;
    font-weight: 700;
    color: #ffffff;
    opacity: 0;
    max-width: 0;
    white-space: nowrap;
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .hollo-recorderSendButton:hover .hollo-recorderSend-text {
    opacity: 1;
    max-width: 40px;
  }
`;
